import { createAction, props } from '@ngrx/store';
import { MapGeometry } from '@core/domain/model/consumption/map-geometry.model';
import { MapCoords } from '@core/domain/model/consumption/map-coords.model';
import { MapFilter } from '@core/domain/model/consumption/map-filter.model';
import { ConsumptionRequest } from '@core/domain/model/consumption/consumption-request.model';
import { PaginatorInput } from '@shared/components/paginator/models/paginator-input.model';
import { SortEvent } from '@shared/components/table/sort/model/sort.model';
import { ConsumptionRequestListFilter } from '@pages/my-consumption/consumption/ui/consumption-request-list/model/consumption-request-list.filter';

import {
  AccumulatedConsumption,
  AccumulatedConsumptionGraphType,
  ComparativeConsumptionByInstallation,
  ComparativeConsumptionGraphType,
  ConsumptionFilter,
} from '@core/domain/model/consumption/consumption.model';

export const consumptionActions = {
  fetchMapGeometry: createAction('[Consumptions Map] Fetch Map Geometry'),
  setMapGeometry: createAction('[Consumptions Map API] Set Map Geometry', props<{ geometry: MapGeometry }>()),
  fetchMapCoords: createAction('[Consumptions Map] Fetch Map Coords'),
  setMapCoords: createAction('[Consumptions Map API] Set Map Coords', props<{ coords: MapCoords[] }>()),
  setMapFilters: createAction('[Consumptions Map] Set Map Filters', props<{ filter: MapFilter }>()),
  setMapGeometryError: createAction('[Consumptions Map API] Set Map Geometry Error', props<{ error: string }>()),
  setMapCoordsError: createAction('[Consumptions Map API] Set Map Coords Error', props<{ error: string }>()),
  fetchRequestList: createAction('[Consumptions Request List] Fetch Request List'),
  setRequestList: createAction('[Consumptions Request List API] Set Request List', props<{ data: ConsumptionRequest[] }>()),
  sortRequestList: createAction('[Consumptions Request List] Sort Request List', props<{ sort: SortEvent }>()),
  pageRequestList: createAction('[Consumptions Request List] Page Request List', props<{ page: PaginatorInput }>()),
  filterRequestList: createAction('[Consumptions Request List] Filter Request List', props<{ filter: ConsumptionRequestListFilter }>()),
  setRequestListError: createAction('[Consumptions Request List API] Set Request List Error', props<{ error: string }>()),
  initTab: createAction('[Consumptions] Initialize which tab to show'),
  changeTab: createAction('[Consumptions] Change tab', props<{ index: number }>()),
  initFilter: createAction('[Consumptions] Set initial filters', props<{ filter: ConsumptionFilter }>()),
  setAccumulatedGraphType: createAction(
    '[Consumptions Accumulated] Set Accumulated Graph Type',
    props<{
      graphType: AccumulatedConsumptionGraphType;
    }>()
  ),
  setAccumulatedFilter: createAction('[Consumptions Accumulated] Set filter', props<{ filter: ConsumptionFilter }>()),
  fetchAccumulatedData: createAction('[Consumptions Accumulated] Fetch accumulated'),
  downloadAccumulatedExcel: createAction('[Consumptions Accumulated] Download accumulated excel'),
  setAccumulatedData: createAction(
    '[Consumptions Accumulated API] Set accumulated data',
    props<{
      previousData: AccumulatedConsumption[] | null;
      currentData: AccumulatedConsumption[] | null;
    }>()
  ),
  setComparativeGraphType: createAction(
    '[Consumptions Comparative] Set Comparative Graph Type',
    props<{
      graphType: ComparativeConsumptionGraphType;
    }>()
  ),
  setComparativeFilter: createAction('[Consumptions Comparative] Set filter', props<{ filter: ConsumptionFilter }>()),
  fetchComparativeData: createAction('[Consumptions Comparative] Fetch comparative'),
  downloadComparativeExcel: createAction('[Consumptions Comparative] Download comparative excel'),
  setComparativeData: createAction(
    '[Consumptions Comparative API] Set comparative data',
    props<{ data: Array<ComparativeConsumptionByInstallation> }>()
  ),
  setComparativeError: createAction('[Consumptions Comparative API] Set comparative error', props<{ error: string }>()),
};
